module.exports = __webpack_public_path__ + "img/login-button.6b3bda0f.png";